export default "__VITE_ASSET__4efb3d22__"